import React from 'react';
import { Text } from '@moda/om';
import { RestAddressAttributes } from '../../../hooks/useAddress';
import { EditableSection } from '../../EditableSection';

interface Props {
  attributes: Omit<RestAddressAttributes, '__typename' | 'source'> | undefined;
  onChange?: () => void;
}

export const ShippingAddressPreview: React.FC<Props> = ({ attributes, onChange }) =>
  attributes ? (
    <EditableSection onChange={onChange}>
      <Text data-testid="shippingAddressInfoBlock">
        <div>
          {attributes.firstName} {attributes.lastName}
        </div>
        <div>{attributes.addressLine1}</div>
        <div>{attributes.addressLine2}</div>
        <div>
          {[attributes.city, attributes.state, attributes.postalCode, attributes.countryCode]
            .filter(Boolean)
            .join(', ')}
        </div>
        <div>{attributes.phone}</div>
      </Text>
    </EditableSection>
  ) : null;
